import addWeeks from 'date-fns/addWeeks';
import subDays from 'date-fns/subDays';

const getEndDate = (startDate: Date, duration: number) => subDays(addWeeks(startDate, duration), 1);

export default getEndDate;
